import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import LinkButton from 'src/app/components/Elements/Button/LinkButton';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { loggedInTransferRx, showYourDoctor } from 'src/app/router/paths';

import { BaseModal } from '../Base/BaseModal';

import type { PropsFromRedux } from './container';
import styles from './styles.module.scss';

interface FamilyModalProps extends PropsFromRedux {
  dispatchModalClosed: (dependentName: string) => void;
  showModal: boolean;
  dependentName: string;
  dispatchSegmentTrack: (event: UnifiedEvent, payload: any) => void;
}

export const FamilyModalRenderer = ({
  dispatchModalClosed,
  showModal,
  dependentName,
  dispatchSegmentTrack,
}: FamilyModalProps) => {
  useSegmentEvent('viewAddFamilyMemberConfirmation', { shouldTrackOnMount: true });

  const familyModalId = 'family-success-modal';
  const familyModalDescribedById = 'family-success-modal-describedby-id';

  const handleTransferRxButtonClick = () => {
    dispatchSegmentTrack(UNIFIED.viewTransferForm, { location: 'Add Family Member Success Modal' });
    dispatchModalClosed(dependentName);
  };

  return (
    <BaseModal
      handleModalClosed={() => dispatchModalClosed(dependentName)}
      // TODO: Will use an optimizely flag here to toggle the modal for the original flow.
      // alex's pr to share the client will be merged to master soon
      showModal={showModal}
      closedEvent={UNIFIED.closeArchiveMedicationFeedback}
      closedEventPayload={{}}
      ariaLabeledById={familyModalId}
      ariaDescribedById={familyModalDescribedById}
    >
      <div className={styles.innerContainer}>
        <h2 id={familyModalId} role="status" className={styles.titleText}>
          All Set. <span>{dependentName}</span> has been added to your account.
        </h2>
        <div className={styles.infoText} id={familyModalDescribedById}>
          Next up: remember to transfer an existing prescription or send a new prescription from their doctor's office.
        </div>
        <LinkButton
          style="primary"
          size="medium"
          onClick={handleTransferRxButtonClick}
          to={loggedInTransferRx.toPath()}
        >
          Transfer RX
        </LinkButton>
        <LinkButton
          style="secondary"
          size="medium"
          onClick={() => dispatchModalClosed(dependentName)}
          to={showYourDoctor.toPath()}
        >
          Send New Prescription
        </LinkButton>
      </div>
    </BaseModal>
  );
};
